export const SCHEDULED_MESSAGE_EDIT_MODAL_ID = 'scheduled-message-edit-modal';
